import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from './supabaseClient';

export default function UniversePage() {
  const { codigo } = useParams();
  const [characters, setCharacters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCharacters = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('characters')
        .select('*')
        .eq('universo', codigo);

      if (!error && data) {
        const sorted = data
          .filter((char) => char.image && char.name)
          .sort((a, b) => a.name.localeCompare(b.name));
        setCharacters(sorted);
      } else {
        console.error(error);
        setCharacters([]);
      }

      setLoading(false);
    };

    fetchCharacters();
  }, [codigo]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2 style={{ fontSize: '1.8rem' }}>🌌 Nubbi Universe: {codigo}</h2>
      {loading ? (
        <p>Loading characters...</p>
      ) : characters.length === 0 ? (
        <p>No characters found for this universe.</p>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
          {characters.map((char) => (
            <div
              key={char.id}
              style={{
                margin: 12,
                textAlign: 'center',
                borderRadius: 12,
                overflow: 'hidden',
              }}
            >
              <img
                src={char.image}
                alt={char.name}
                style={{
                  width: '100%',
                  maxWidth: 200,
                  height: 'auto',
                  borderRadius: 12,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                }}
              />
              <p style={{ fontWeight: 'bold', marginTop: '0.5rem' }}>{char.name}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


